import React from 'react';
import CaseStudys from '../index';
import styles from './styles.module.scss';
import amberaromabanner from '../../../assets/casestudy/amberaromabanner.webp';
import amberarom1stimg from '../../../assets/casestudy/amberarom1stimg.webp';
import amberaroma3rdimg from '../../../assets/casestudy/amberaroma3rdimg.webp';
import amberaroma2ndimg from '../../../assets/casestudy/amberaroma2ndimg.webp';
import assetglacne1img from '../../../assets/casestudy/assetglacne1img.webp';
import Devangi1stimg from '../../../assets/casestudy/Devangi1stimg.webp';
import Mongodbicon from '../../../assets/img/mongodbicon.svg';
import Nodeicon from '../../../assets/img/nodeicon.svg';
import Reacticon from '../../../assets/img/reacticon.svg';
import Expressicon from '../../../assets/img/expressicon.svg';

const AmberAroma = () => {
  const caseStudiesB = [
  {
    image: assetglacne1img,
    title: 'Asset Glance',
    category: 'Website Design',
    link: 'https://assetglance.com/',
     pagelink:'/assetglance',
  },
  {
    image: Devangi1stimg,
    title: 'Devangi Atithya',
    category: 'Website Design',
    link: ' https://devangiatithya.com/',
     pagelink:'/devangiAtithya',
  },
];
  const servicesB = [
  { label: 'UI & UX Design', link: 'https://metasoft.ae/services' },
  { label: 'Web Development', link: 'https://metasoft.ae/services' },
  { label: 'Performance Optimization', link: 'https://metasoft.ae/services'},
  { label: 'SEO', link: 'https://metasoftdm.com/marketing-solutions/seo/'},
];
  return (
    <CaseStudys
      title="Amber Aroma"
      caseStudies={caseStudiesB} 
      subtitle="Elevating Spaces with Signature Scents"
      header='Elevating Spaces with Signature Scents'
      websiteUrl='https://amberaroma.com/'

      industry="Luxury Scents & Aroma Solutions"
     services={servicesB}
      description={
        <>
          <span>Amber Aroma </span> is a fragrance brand dedicated to crafting luxurious, amber-inspired scents that evoke warmth, elegance, and timeless allure. To bring this vision to life online, we designed and developed a website that reflects the brand’s refined identity while offering a seamless experience for customers to explore and shop their signature perfumes. The project focused on creating a visually rich, intuitive platform that highlights the sensory depth of amber and supports Amber Aroma’s mission to deliver sophistication through scent.(Floris London)
        </>
      }
      objective={{
        heading: 'Helping Amber Aroma Connect with Customers Through a Beautiful Website',
        content: (
          <>
            <p className={styles.projectText}>
         The objective of the Amber Aroma website project was to craft a refined and immersive digital experience that reflects the brand’s commitment to luxury, elegance, and the art of fragrance. The goal was to design a visually compelling and intuitive e-commerce platform that not only showcases the depth and character of each amber-based perfume but also enhances the overall customer journey—from discovery to purchase. This project aimed to align the brand’s digital presence with its sophisticated identity, build trust with a premium audience, and support business growth through a seamless and engaging online shopping experience.
            </p>

           
          </>
        ),
      }}
      process={{
        heading: "How We Created a Warm and Easy-to-Use Website for Their Users",
        content: (
          <>
            <p className={styles.projectText}>
       The launch of the Amber Aroma website elevated the brand’s digital presence, making it easier for customers to explore and purchase its luxurious fragrances online. The elegant design and intuitive layout helped convey the brand’s premium identity, while the seamless shopping experience increased customer engagement and trust. As a result, the website contributed to stronger brand recognition, higher conversion rates, and a more efficient path from product discovery to purchase.
            </p>

         

           
          </>
        ),
      }}
      impact={{
        heading: 'Making It Easy for Customers to Discover and Buy Products',
        content: (
          <>
            <p className={styles.projectText}>
        The launch of the Amber Aroma website elevated the brand’s digital presence, making it easier for customers to explore and purchase its luxurious fragrances online. The elegant design and intuitive layout helped convey the brand’s premium identity, while the seamless shopping experience increased customer engagement and trust. As a result, the website contributed to stronger brand recognition, higher conversion rates, and a more efficient path from product discovery to purchase.
            </p>
           
           
          </>
        ),
      }}
       conclusion={{
        heading: 'Wrapping Up the Project',
        content: (
          <>
            <p className={styles.projectText}>
In conclusion, the Amber Aroma website successfully translated the brand’s luxurious and sophisticated essence into a compelling digital experience. By combining elegant design with intuitive functionality, the platform now serves as a strong foundation for customer engagement, online sales, and brand storytelling. The project not only enhanced the brand's online presence but also positioned Amber Aroma to grow within the premium fragrance market.
            </p>
           
          </>
        ),
      }}
      heroImage={amberaromabanner} // Add the hero image
      projectImage={amberarom1stimg}
       projectImage2={amberaroma2ndimg}
           projectImage3={amberaroma3rdimg}
       // Add the project image
      technologies={[
           { name: 'MongoDB', icon: Mongodbicon },
        { name: 'Node.js', icon: Nodeicon },
        { name: 'React', icon: Reacticon },
        { name: 'Express.js', icon: Expressicon },
      ]} // Add the technologies used
      timescale="On-going" // Add the timescale
      launchDate="Nov 2024" // Add the launch date
    />
  );
};

export default AmberAroma;